/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'expand': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: '<defs><filter id="svgicon-expand-a"><feColorMatrix in="SourceGraphic" values="0 0 0 0 0.886275 0 0 0 0 0.341176 0 0 0 0 0.341176 0 0 0 1.000000 0"/></filter></defs><g _fill="#000" fill-rule="nonzero" transform="translate(-638 -424)" filter="url(#svgicon-expand-a)"><path pid="0" d="M651.74 424.573h-3.862a.724.724 0 0 0 0 1.448h2.113l-6.941 6.942a.724.724 0 0 0 1.024 1.024l6.942-6.942v2.114a.724.724 0 0 0 1.448 0v-3.862c0-.4-.324-.724-.724-.724z"/><path pid="1" d="M651.74 431.332c-.4 0-.724.324-.724.724v5.069h-11.104V426.02h5.069a.724.724 0 1 0 0-1.448h-5.793c-.4 0-.724.324-.724.724v12.552c0 .4.324.724.724.724h12.552c.4 0 .724-.324.724-.724v-5.793c0-.4-.324-.724-.724-.724z"/></g>'
  }
})
